import * as Cookies from 'js-cookie';

export const isAuthenticated = () => {
  return Cookies.get('LOGGED-IN') === '1';
};
